import {
    getMultiSelectMessage,
    getReqMessage
} from '../../../../../utils/formValidation/errorMessageFunctions';

export const validate = (newEntry) => {
    let newErrors = {};

    if (!newEntry.goldStandardCVId) {
        newErrors = {
            ...newErrors,
            goldStandardCVId: { error: true, message: getReqMessage('Gold Standard CV') }
        };
    }

    if (!newEntry.jobSectorId) {
        newErrors = {
            ...newErrors,
            jobSectorId: { error: true, message: getReqMessage('Job Sector') }
        };
    } else if (!newEntry.participantPoolIds?.length) {
        newErrors = {
            ...newErrors,
            participantPoolIds: { error: true, message: getMultiSelectMessage('Pool') }
        };
    }

    return newErrors;
};
